import React from 'react';
import { Form, FormGroup, Button } from 'react-bootstrap';
import FieldInput from '../FormComponents/FieldInput';
import DateTimeInput from '../FormComponents/DateTimeInput';
import DropdownListInput from '../FormComponents/DropdownListInput';
import { Field, reduxForm } from 'redux-form';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
import SelectListInput from '../FormComponents/SelectListInput';
momentLocalizer(moment);

const required = value => (value === undefined ? 'Required' : undefined);
const minLength1 = value =>
      value && value.length < 1 ? `Must be 1 characters or more` : undefined;
const validProd = value => (value && value._id ? undefined : 'Required');
const getDateLimits = (month, allowDateOverride) => {
  const monthStart = moment(month + '01');
  const monthEnd = moment(month + '01').endOf('month');
  const today = moment();
  const weekStart = today.clone().startOf('isoWeek');
  const mondayLimit = today.isoWeekday() === 1
    ? weekStart.clone().subtract(7, 'days')
    : weekStart;
  const minDate = allowDateOverride
    ? monthStart
    : moment.max(monthStart, mondayLimit);
  const maxDate = moment.min(monthEnd, today);
  return {
    minDate: minDate.toDate(),
    maxDate: maxDate.toDate()
  };
};
const dateRangeError = (value, minDate, maxDate) => {
  if (!value) return undefined;
  let parsed = moment(value, ['YYYY-MM-DD', moment.ISO_8601], true);
  if (!parsed.isValid()) {
    parsed = moment(value);
  }
  if (!parsed.isValid()) return 'Invalid date';
  const min = moment(minDate).startOf('day');
  const max = moment(maxDate).endOf('day');
  if (parsed.isBefore(min) || parsed.isAfter(max)) {
    return `Date must be between ${min.format('YYYY-MM-DD')} and ${max.format('YYYY-MM-DD')}`;
  }
  return undefined;
};

const validateForm = (values, props) => {
  const errors = {};
  if (props.month) {
    const limits = getDateLimits(props.month, props.allowDateOverride);
    const error = dateRangeError(values.date, limits.minDate, limits.maxDate);
    if (error) errors.date = error;
  }
  return errors;
};
    
const ListItem = ({item}) => {
  if(!item._id) {
    return <span>Select</span>;
  } else {
    return (
      <div>
        <p><strong>Operation: </strong>{item.op_code} {item.op_desc&& ` - ${item.op_desc}`}</p>
        <p><strong>Article: </strong>{item.prod_code} {item.prod_desc&& ` - ${item.prod_desc}`}</p>
        <p><strong>Department: </strong>{item.department}</p>
      </div>
    );
  }
}

class WorkItemForm extends React.Component {
 
  render(){
    const dateLimits = getDateLimits(this.props.month, this.props.allowDateOverride);
    const { handleSubmit, pristine, submitting, products, working_time, orderNumbers } = this.props;
    return (
      <Form horizontal onSubmit={handleSubmit}>
        <h1>Report of work</h1>
        <Field 
          id="date" name="date" label="Date"
          type="text" component={DateTimeInput}
          validate={[required]}
          date_format="YYYY-MM-DD"
          time={false}
          month={this.props.month}
          min={dateLimits.minDate}
          max={dateLimits.maxDate}
        />
        <Field
          id="product" name="product" label="Article no."
          className="form-control" 
          component={DropdownListInput} 
          textField={item=>{
            return !item.op_code?'':`${item.op_code} ${item.op_desc} ${item.prod_code} ${item.prod_desc} ${item.department}`
          }}
          valueField={item=>item&&item._id}
          filter={(x,y)=>{
            let s=y.toLowerCase().split(' ');
            let t=`${x.prod_code} ${x.prod_desc} ${x.op_code} ${x.op_desc} ${x.department}`.toLowerCase();
            return s.reduce((a,b)=>a&&t.indexOf(b)>-1,true);
          }} 
          itemComponent={ListItem}
          valueComponent={ListItem}
          groupBy='department'
          data={products}
          validate={[required,validProd]} />
        <Field 
          id="order-number" name="order_number"  label="Order Number / Work description" 
          type="text" className="form-control" placeholder="Order #" list="order-number-list"
          validate={[required,minLength1]} component={FieldInput}/>
        <datalist id="order-number-list">
          {(orderNumbers||[]).map(value=>(
            <option key={value} value={value} />
          ))}
        </datalist>
        <Field 
          id="pieces" name="pieces" label="Pcs / Hours" 
          type="text" className="form-control" placeholder="# of pieces / hours" validate={[required]} component={FieldInput}/>
        <Field
          id="workingtime" name="working_time" label="Working Time"
          data={working_time}
          textField="name"
          valueField="name"
          type="text" 
          validate={[required]} 
          component={SelectListInput} 
          parse={value =>
            (working_time || []).find(item => item && item.name === value) || value
          }
          />
        <FormGroup className="form-actions">
          <Button type="submit" bsStyle="primary" disabled={pristine || submitting}>
            {this.props.initialValues&&this.props.initialValues._id?'Save':'Create'}
          </Button>
          {/* <Button className="pull-right" onClick={this.props.logout}>Logout</Button> */}
          <Button className="pull-right" onClick={this.props.goBack}>Close</Button>
        </FormGroup>
      </Form>
    );
  }
}

export default reduxForm({form:'workItemForm', validate: validateForm})(WorkItemForm);
